export default __webpack_public_path__ + "static/media/MyResume.c45a082f.pdf";